import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'

import MapView from '../core/map/MapView.vue'
import MapDefaultMarker from '../core/map/MapDefaultMarker.vue'
import MapMarker from '../core/map/MapMarker.vue'
import DiscoverTripPlan from '@/components/discover/DiscoverTripPlan.vue'
import { waypointModule } from '@/store'
import { Waypoint } from '@/types/trip'


export default /*#__PURE__*/_defineComponent({
  __name: 'DiscoverMap',
  props: {
    locations: null
  },
  setup(__props: any) {

const props = __props as {
  locations: Waypoint[]
};


const currentWaypoint = computed(() => waypointModule.waypoint)
const currentPOI = computed(() => waypointModule.pointOfInterest)

const viewport = ref<google.maps.LatLngBounds>()
const zoom = ref(8)

function fitBoundsToContent() {
  const bounds = new google.maps.LatLngBounds()

  props.locations.forEach((waypoint) => {
    bounds.extend(
      new google.maps.LatLng(
        waypoint.location.latitude,
        waypoint.location.longitude,
      ),
    )

    waypoint.pointOfInterests.forEach((poi) => {
      if (poi.location) {
        bounds.extend(
          new google.maps.LatLng(poi.location.latitude, poi.location.longitude),
        )
      }
    })
  })

  viewport.value = bounds
}

onMounted(fitBoundsToContent)

watch(currentWaypoint, (newWaypoint) => {
  if (!newWaypoint) {
    return fitBoundsToContent()
  }

  // pan to the current waypoint with a larger zoom area
  const latOffset = 0.3
  const lngOffset = 0.3

  const newBounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(
      newWaypoint.location.latitude - latOffset,
      newWaypoint.location.longitude - lngOffset,
    ),
    new google.maps.LatLng(
      newWaypoint.location.latitude + latOffset,
      newWaypoint.location.longitude + lngOffset,
    ),
  )

  newWaypoint.pointOfInterests.forEach((poi) => {
    if (poi.location) {
      newBounds.extend(
        new google.maps.LatLng(poi.location.latitude, poi.location.longitude),
      )
    }
  })

  viewport.value = newBounds
})

watch(currentPOI, (newPOI) => {
  if (!newPOI || !newPOI.location) {
    return fitBoundsToContent()
  }

  // pan to the current POI with a larger zoom area
  const latOffset = 0.3
  const lngOffset = 0.3

  viewport.value = new google.maps.LatLngBounds(
    new google.maps.LatLng(
      newPOI.location.latitude - latOffset,
      newPOI.location.longitude - lngOffset,
    ),
    new google.maps.LatLng(
      newPOI.location.latitude + latOffset,
      newPOI.location.longitude + lngOffset,
    ),
  )
})

return { __sfc: true,props, currentWaypoint, currentPOI, viewport, zoom, fitBoundsToContent, MapView, MapDefaultMarker, MapMarker, DiscoverTripPlan }
}

})